import React from 'react';
import { useAppSelector } from 'flow/hooks/useRedux';
import { generatePath, useHistory, useParams } from 'react-router-dom';

import CallStrategyGuide from 'flow/components/guide/CallStrategyGuide';
import Loading from 'flow/components/ui-components/Loading';
import Page from 'flow/components/Setting/Page';
import SettingSection from 'flow/components/Setting/SettingSection';
import RouteLink from 'flow/components/ui-components/RouteLink';
import useAppContext from 'flow/hooks/useAppContext';
import { PbxParams } from 'flow/types/Params';
import { routes } from 'flow/types/routes';

import { StrategyState } from 'flow/utils';

const PbxCallStrategy = () => {
    const { i18next } = useAppContext();
    const history = useHistory();
    const { queueKey } = useParams<PbxParams>();
    const queue = useAppSelector((state) =>
        state.pbx.getIn(['queues', queueKey]),
    );

    if (!queue?.has('settings')) {
        return <Loading />;
    }

    return (
        <Page
            header={i18next.t('Queue.Settings.List.CallStrategy')}
            onClickBack={() =>
                history.push(
                    generatePath(routes['pbx.queues.entityKey.settings'], {
                        entityKey: queueKey,
                    }),
                )
            }
        >
            <div className="text-xs text-gray-500">
                {i18next.t('Queue.CallStrategy.TableHeaderTitle')}
            </div>

            <RouteLink
                to={generatePath(
                    routes['pbx.queues.queueKey.settings.callstrategy.edit'],
                    { queueKey },
                )}
                description={i18next.t(
                    `Queue.CallStrategy.Item.${
                        StrategyState[queue.get('queueCallStrategy')].value
                    }`,
                )}
            >
                {i18next.t('Queue.Settings.List.CallStrategy')}
            </RouteLink>

            <SettingSection>
                {i18next.t('Queue.CallStategy.LearnAboutCallStrategies')}
            </SettingSection>

            <CallStrategyGuide strategy={queue.get('queueCallStrategy')} />
        </Page>
    );
};

export default PbxCallStrategy;
